module.exports = __webpack_public_path__ + "static/media/background.5b137fc2.jpg";